import axios from '@/utils/axios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        itemType: null,
        itemTypes: []
    },
    mutations: {
        setItemType(state, payload) {
            state.itemType = payload;
        },
        setItemTypes(state, payload) {
            state.itemTypes = payload;
        }
    },
    actions: {
        storeItemType({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/item-types`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        updateItemType({rootState, dispatch}, payload) {
            return new Promise((resolve, reject)=> {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/item-types/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeItemType({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/item-types/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        removeItemTypes({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/item-types`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchItemType({commit, rootState, dispatch}, payload) {
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-types/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItemType', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        },
        fetchItemTypes({commit, rootState, dispatch}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-types?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItemTypes', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        }

    }
}